import React, { useCallback, useEffect } from "react";

import { SelectInput } from "../SelectInput";
import { Button } from "react-bootstrap";
import { ChecklistConfigsService } from "../../services";
import Dropzone from 'react-dropzone';

const contentTypeOptions = [
    { label: "PDF", value: "pdf" },
    { label: "Image", value: "image" }
];

const FileArea = ({ contentToken, contentFile, meta, onChange, viewContentAction }) => (
    <div>
        {contentToken && !contentFile && (
            <div className="row" style={{paddingLeft: 16, paddingBottom: 10}}>
                <Button onClick={viewContentAction}>View Existing Content</Button>
            </div>
        )}
        {contentFile && (
            <div className="row" style={{paddingLeft: 16}}>
                <div className="col-sm-12">{contentFile.name}</div>

                <div className="col-sm-12">
                    <Button onClick={() => onChange(null)}>Remove</Button>
                </div>
            </div>
        )}
        {!contentFile && (
            <Dropzone onDrop={(files) => onChange(files[0])} onBlur={(event) => event.preventDefault()} className="dropzone-format" multiple={false}>
                <div style={{ textAlign: "center", top: "45%", position: "relative" }}>Drag File here or...</div>
                <button type="button" style={{ margin: "0 auto", display: "block", position: "relative", top: "110px" }} className="btn btn-sm btn-default">
                    Select File
                </button>
            </Dropzone>
        )}
        {meta.touched && meta.error && <span className="input-error">{meta.error}</span>}
    </div>
);

const ContentStep = ({ step, readOnly, onStepUpdate }) => {

    useEffect(() => {
        if (!step.contentType) {
            onStepUpdate({ ...step, contentType: contentTypeOptions[0].value });
        }
    }, [step]);

    const updateContentType = useCallback((contentTypeOption) => {
        onStepUpdate({ ...step, contentType: contentTypeOption.value });
    }, [step, onStepUpdate]);
    
    const updateContentFile = useCallback((file) => {
        var extName = file?.name.split(".").pop();;
        onStepUpdate({ ...step, contentFile: file, contentToken: `${crypto.randomUUID()}${extName ? '.'+extName : ''}`, uploadNeeded: true });
    }, [step, onStepUpdate]);

    const viewContentAction = useCallback(() => {
        ChecklistConfigsService.getContentURL(step.contentToken)
            .then(({ contentURL }) => {
                window.open(contentURL, "_blank").focus();
            })
            .catch((error) => {
                console.error(error);
            });
    }, [step]);

    return (step.checklistTaskOptionType.token === "content") && (
        <div>
            <div className="form-group">
                <label>Content Type</label>
                <SelectInput
                    input={{
                        value: step.contentType ? contentTypeOptions.find((contentType) => contentType.value === step.contentType) : contentTypeOptions[0],
                        onChange: updateContentType
                    }}
                    isDisabled={readOnly}
                    options={contentTypeOptions}
                    isSearchable={false}
                    meta={step.errors && step.errors.contentType ? { touched: true, error: step.errors.contentType } : {}}
                />

                <br/>

                <label>Content Upload</label>
                {readOnly ? 
                    <span><Button onClick={viewContentAction}>View Content</Button></span> 
                    : 
                    <FileArea
                        contentToken={step.contentToken}
                        contentFile={step.contentFile}
                        onChange={updateContentFile}
                        viewContentAction={viewContentAction}
                        meta={step.errors && step.errors.contentFile ? { touched: true, error: step.errors.contentFile } : {}}
                    />
                }
            </div>
        </div>
    );
};

export default ContentStep;
